const getModuleState = state => state.configurationParameter;

export const getTotalConfigurationParameters = state =>
    getModuleState(state).totalConfigurationParameter;